import { Toast, ToastProvider } from "@uhg-harmony/react";
import type { FC, ReactNode } from "react";
import styled from "styled-components";
import { useToastStore } from "../store/toastStore";

interface ToastProviderWrapperProps {
  children: ReactNode;
  duration?: number;
}

const NotificationToast = styled(Toast)`
  width: min(420px, calc(100vw - 32px));
  max-width: calc(100vw - 32px);

  &,
  * {
    white-space: normal;
    overflow-wrap: anywhere;
    word-break: break-word;
  }
`;

const ToastProviderWrapper: FC<ToastProviderWrapperProps> = ({ children, duration = 10000 }) => {
  const { toastMessage, toastHeader, toastVariant, showToast, hideToast } =
    useToastStore();

  return (
    <ToastProvider>
      {children}
      {showToast && (
        <NotificationToast
          variant={toastVariant as Parameters<typeof Toast>[0]["variant"]}
          alignment="top-right"
          dismissible
          duration={duration}
          announcementPriority="polite"
          onDismiss={hideToast}
          message={toastMessage}
          headerText={toastHeader}
        />
      )}
    </ToastProvider>
  );
};

export { ToastProviderWrapper };
